module.exports = __webpack_public_path__ + "static/img/equipmentBack.721fefab.png";